import { defineComponent, inject, ref, computed, watch, toRefs, onMounted, onActivated, onDeactivated, onBeforeUnmount, onUnmounted } from '@vue/composition-api';
import RuntimeReport from '@/reporter/RuntimeReport';
import { useStore } from '@/store';
import { TYPE, PAGE_TYPE } from '@/loaders/page/consts';
import { getAppParams } from '@/utils/getAppParams';
import { useGogoWatermark } from '@components/watermark/useGogoWatermark';
export default defineComponent({
    name: 'GogoPortalRuntimeRouterView',
    props: {
        projectId: {
            type: String,
            required: true,
        },
        pageId: {
            type: String,
            required: true,
        },
        forcePath: {
            type: String,
            default: '',
        },
        forceProps: {
            type: Object,
            default: null,
        },
    },
    setup(props) {
        const { pageId } = toRefs(props);
        const gogoRef = ref(null);
        const routeViewRef = ref(null);
        const reporter = ref(null);
        const store = useStore();
        const extraHostClass = inject('gogoPortalHostClass', '');
        const routeViewContainer = inject('routeViewContainer');
        const hostReady = inject('gogoHostReady', ref(true));
        const gogoRuntimeViewInstances = inject('gogoRuntimeViewInstances');
        const self = { pageId };
        gogoRuntimeViewInstances.value = [...gogoRuntimeViewInstances.value, self];
        onUnmounted(() => {
            gogoRuntimeViewInstances.value = gogoRuntimeViewInstances.value.filter(item => item !== self);
        });
        const claimRouteViewContainer = () => {
            routeViewContainer.value = routeViewRef.value;
        };
        const releaseRouteViewContainer = () => {
            if (routeViewContainer.value === routeViewRef.value) {
                routeViewContainer.value = null;
            }
        };
        // 如果页面被keep-alive，则只在 activated 时认领，在 deactivated 时释放。
        onMounted(claimRouteViewContainer);
        onActivated(claimRouteViewContainer);
        onDeactivated(releaseRouteViewContainer);
        onBeforeUnmount(releaseRouteViewContainer);
        const project = computed(() => store.state.runtime.project);
        const page = ref({});
        const getPageDetail = async (id) => await store.dispatch('runtime/getPageDetail', {
            projectId: props.projectId,
            pageId: id,
            env: getAppParams('env'),
            branch: getAppParams('branch'),
        });
        const { rendererGogoWatermark } = useGogoWatermark();
        onMounted(() => {
            watch(() => pageId.value, async (newPageId, oldPageId) => {
                if (!newPageId || newPageId === oldPageId)
                    return;
                page.value = await getPageDetail(newPageId);
                rendererGogoWatermark({
                    id: 'wuji-pagelet-watermark',
                    container: gogoRef.value,
                    project: project.value,
                    page: page.value,
                });
            }, { immediate: true });
            watch(() => pageId.value, (newPageId, oldPageId) => {
                const { projectId, env } = window.RUNTIME_CONFIGS;
                if (oldPageId && reporter.value) {
                    reporter.value?.pgOut()?.destroy();
                    reporter.value = null;
                }
                reporter.value = new RuntimeReport({
                    isAIPage: true,
                    projectInfo: {
                        projectId,
                        projectName: project.value?.name,
                        parentId: project.value?.parentId,
                    },
                    pageId: newPageId,
                    envId: env,
                    pageInfo: {
                        type: TYPE.AI,
                        pageType: PAGE_TYPE.CONTENT,
                        contentType: 'normal',
                    },
                    $dom: gogoRef.value,
                    agentReport: project.value?.advanceConfig?.agentReport ?? false,
                });
                reporter.value.pv();
            }, { immediate: true });
        });
        onBeforeUnmount(() => {
            reporter.value?.pgOut()?.destroy();
            reporter.value = null;
        });
        return {
            gogoRef,
            routeViewRef,
            hostReady,
            extraHostClass,
        };
    },
});
